import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import PageSection from '../../../../../features/components/PageSection'
import Icon from '../../../../../components/Icon'
import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/download-icon.svg'
import HoverHelpTextIcon from '../../../../../features/components/HoverHelpTextIcon'

import { exportChartAsPng } from '../../helpers/exportChart'

import { EXPORT_CHART_ICON_ID } from '../../constants'

import useStyles from '../styles'

const GraphContainer = ({
  title,
  totalValue,
  totalValueDescription,
  children,
  legendContainerId,
  className,
  headingContainerClassName,
  headingChildren,
  id,
  onExportStart,
  onExportEnd,
  helpText
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const handleChartExport = useCallback(() => {
    if (id) {
      exportChartAsPng({
        chartId: id,
        title: t(title),
        onExportStart,
        onExportEnd
      })
    }
  }, [id, title, t, onExportStart, onExportEnd])

  return (
    <PageSection id={id} className={classnames(classes.sectionContainer, className)}>
      <div onClick={handleChartExport} id={EXPORT_CHART_ICON_ID}>
        <Icon className={classes.downloadIcon}>
          <DownloadIcon />
        </Icon>
      </div>
      <div className={classnames(classes.headingContainer, headingContainerClassName)}>
        <div className={classes.left}>
          <div className={classes.title}>
            {t(title)} {helpText && <HoverHelpTextIcon helpText={helpText} />}
          </div>
          <div className={classes.value}>
            {totalValue}
            {totalValueDescription && <span className={classes.valueDescription}>{' ' + totalValueDescription}</span>}
          </div>
        </div>

        {legendContainerId && (
          <div id={legendContainerId}>{/*// The legend of the graph will be rendered here by the plugin*/}</div>
        )}

        {headingChildren && <div>{headingChildren}</div>}
      </div>
      {children}
    </PageSection>
  )
}

GraphContainer.propTypes = {
  title: PropTypes.string.isRequired,
  totalValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalValueDescription: PropTypes.string,
  children: PropTypes.node.isRequired,
  legendContainerId: PropTypes.string,
  className: PropTypes.string,
  headingContainerClassName: PropTypes.string,
  headingChildren: PropTypes.node,
  id: PropTypes.string,
  onExportStart: PropTypes.func,
  onExportEnd: PropTypes.func,
  helpText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired
        })
      )
    })
  ])
}

export default GraphContainer
